import React, { useEffect, useState } from "react";
import { getData, postData } from "../../api/ApiServices";
import "../../styles/ItemOutward.css";
import "../../styles/common/toplayout.css";
import "../../styles/common/btn.css";
import "../../styles/GRNFormRadio.css";
import "../../styles/grnformvalidation.css";
import "../../styles/inward_outward/inward.css"; 
import { useDispatch, useSelector } from "react-redux";
import { setFocusedField } from "../../redux/slices/focusSlice";
import TableComponent from "../TableComponent";
import { resetFilters, updateFilters } from "../../redux/slices/filterSlice";
import Pagination from "../../view/common/pagination/Pagination";
import { RootState } from "../../redux/slices/store";
import inwardStyles from "../../styles/inward.module.css";
import {ApiResponse,ScanItem,Rack,Barcode} from '../../models/inward/types';

const DuplicateEntryPopup: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  return (
    <div className="popup-overlay-inward">
      <div className="duplicate-popup-inward">
        <div className="duplicate-popup-icon-inward">
          <div className="close-icon-inward" onClick={onClose}>✕</div>
        </div>
        <div className="duplicate-popup-content-inward">
          <h3>Duplicate Barcode.</h3>
        </div>
        <div className="duplicate-popup-footer-inward">
          <button className="ok-button-inward" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

const Scaninward: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [scanItems, setScanItems] = useState<ScanItem[]>([]);
  const [racks, setRacks] = useState<Rack[]>([]);
  const [availableBarcodes, setAvailableBarcodes] = useState<Barcode[]>([]);
  const [barcodeNo, setBarcodeNo] = useState<string>("");
  const [selectedRack, setSelectedRack] = useState<string>("");
  const [selectedRackName, setSelectedRackName] = useState<string>("");
  const [barcode, setBarcode] = useState<string>("");
  const [partNo, setPartNo] = useState<string>("");
  const [partName, setPartName] = useState<string>("");
  const [model, setModel] = useState<string>("");
  const [category, setCategory] = useState<string>("");
  const [uom, setUom] = useState<string>("");
  const [qty, setQty] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: string;
  }>({
    key: "createdAt",
    direction: "desc",
  });

  const [showDuplicatePopup, setShowDuplicatePopup] = useState<boolean>(false);

  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [editingItem, setEditingItem] = useState<ScanItem | null>(null);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
  const [errors, setErrors] = useState({
    barcodeNo: "",
    selectedRack: "",
    qty: "",
  });

  const [selectedBarcodeTagId, setSelectedBarcodeTagId] = useState<string>("");
  const [isLoadingBarcode, setIsLoadingBarcode] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [sortBy, setSortBy] = useState<string>("createdAt");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
  const [inwardData, setInwardData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const dispatch = useDispatch();
  const filters = useSelector((state: RootState) => state.filters);
  const permission = useSelector((state: RootState) => state.permissions)

  const [initializeInward, isInitializeinward] = useState(false);

  useEffect(() => {
    dispatch(resetFilters());
    isInitializeinward(true);
  }, [dispatch]);

  useEffect(() => {
    fetchRacks();
    fetchAvailableBarcodes();
    fetchBarcodeItems();
  }, []);

  useEffect(() => {
    fetchBarcodeItems();
  }, [filters, sortConfig]);

  const fetchRacks = async () => {
    try {
      const response = await getData<any>("/racks", {});
      if (
        response &&
        response.data &&
        response.data.racks &&
        Array.isArray(response.data.racks)
      ) {
        setRacks(response.data.racks);
      } else {
        console.error("Invalid response format for racks", response);
        setRacks([]);
      }
    } catch (error) {
      console.error("Error fetching racks:", error);
      setRacks([]);
    }
  };

  const fetchAvailableBarcodes = async () => {
    try {
      const response = await getData<any>("/barcode/inward/{barcode}", {
        filter: { type: "INCOMING" },
      });

      if (
        response &&
        response.data &&
        response.data.data &&
        Array.isArray(response.data.data)
      ) {
        setAvailableBarcodes(response.data.data);
      } else {
        console.error("Invalid response format for barcodes", response);
        setAvailableBarcodes([]);
      }
    } catch (error) {
      console.error("Error fetching available barcodes:", error);
      setAvailableBarcodes([]);
    }
  };

  const fetchBarcodeItems = async () => {
    setLoading(true);
    try {
      const params = {
        filter: { ...filters, type: "OUTGOING" },
        sortBy: sortConfig.key,
        sortOrder: sortConfig.direction as "asc" | "desc",
      };

      const response = await getData<any>("/barcode", params);

      if (
        response &&
        response.data &&
        response.data.data &&
        Array.isArray(response.data.data)
      ) {
        setScanItems(response.data.data);
      } else {
        setScanItems([]);
      }
    } catch (error) {
      console.error("Error fetching barcode items:", error);
      setScanItems([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchBarcodeDetails = async (barcodeNumber: string) => {
    if (!barcodeNumber.trim()) {
      resetFormFields();
      return;
    }

    setError("");
    setIsLoadingBarcode(true);
    setFormSubmitted(false);

    try {
      const response = await getData<any>(
        `/barcode/inward/${barcodeNumber}`,
        {}
      );

      if (response && response.statusCode === 1001 && response.data) {
        const item = Array.isArray(response.data)
          ? response.data[0]
          : response.data;

        if (item) {
          setSelectedBarcodeTagId(item._id || "");
          setBarcode(item.tagNumber || "");
          setQty(item.qty?.toString() || "");

          if (item.rackId) {
            const rackId =
              typeof item.rackId === "object" ? item.rackId._id : item.rackId;
            const rackName =
              typeof item.rackId === "object" ? item.rackId.rackName : "";

            setSelectedRack(rackId);
            if (rackName) {
              setSelectedRackName(rackName);
            } else {
              const rackInfo = racks.find((rack) => rack._id === rackId);
              setSelectedRackName(rackInfo ? rackInfo.rackName : "");
            }
          }

          if (item.partId && item.partId.part) {
            const partData = item.partId.part;

            setPartNo(partData.externalPartNo || partData.internalPartNo || "");
            setPartName(partData.partName || "");

            if (partData.modelId) {
              setModel(partData.modelId.name || "");
            } else if (partData.model) {
              setModel(
                typeof partData.model === "object"
                  ? partData.model.name
                  : partData.model
              );
            }

            if (partData.categoryId) {
              setCategory(partData.categoryId.name || "");
            } else if (partData.category) {
              setCategory(
                typeof partData.category === "object"
                  ? partData.category.name
                  : partData.category
              );
            }

            if (partData.uomId) {
              setUom(partData.uomId.name || "");
            } else if (partData.uom) {
              setUom(
                typeof partData.uom === "object"
                  ? partData.uom.name
                  : partData.uom
              );
            }
          }

          setErrors({
            barcodeNo: "",
            selectedRack: "",
            qty: "",
          });

          setSuccessMessage("Barcode details retrieved successfully");
          const itemRackId = typeof item.rackId === "object" ? item.rackId._id : item.rackId;
          handleInwardProcess(item._id || "", barcodeNumber, itemRackId, item.qty?.toString() || "");

          setTimeout(() => {
            setSuccessMessage("");
          }, 3000);
        } else {
          setError("Barcode not found");
          setErrors({
            ...errors,
            barcodeNo: "Barcode not found"
          });
          resetFormFields();
        }
      } else {
        const errorMessage = response?.message || response?.msg || "Barcode not found or invalid";
        setError(errorMessage);
        setErrors({
          ...errors,
          barcodeNo: errorMessage
        });
        resetFormFields();
      }
    } catch (error) {
      console.error("Error fetching barcode details:", error);
      setError("Error retrieving barcode details. Please try again.");
      setErrors({
        ...errors,
        barcodeNo: "Error retrieving barcode details. Please try again."
      });
      resetFormFields();
    } finally {
      setIsLoadingBarcode(false);
    }
  };
  const handleInwardProcess = async (tagId: string, tagNumber: string, rackId: string, quantity: string) => {
    if (!tagId || !tagNumber || !rackId || !quantity) {
      console.error("Missing required data for inward processing");
      return;
    }

    setIsProcessing(true);
    try {
      const today = new Date().toISOString().split("T")[0];

      const outwardData = {
        tagNumber: tagNumber,
        tagId: tagId,
        date: today,
        rackId: rackId,
        qty: parseInt(quantity),
      };

      const response = await postData<ApiResponse>(
        "/inwardoptions",
        outwardData
      );

      if (
        response &&
        "statusCode" in response &&
        (response.statusCode === 1127 || response.statusCode === 1001)
      ) {
        setSuccessMessage("Item inward processed successfully");

        let responseData = response.data;
        if (Array.isArray(response.data)) {
          responseData = response.data[0];
        }

        const rackInfo = racks.find((rack) => rack._id === rackId);
        const rackName = rackInfo ? rackInfo.rackName : "N/A";

        const newItem: ScanItem = {
          _id: responseData._id || Date.now().toString(),
          tagNumber: responseData.tagNumber || tagNumber,
          partNo: partNo,
          partName: partName,
          model: model,
          category: category,
          rackId: responseData.rackId || rackId,
          rackName: rackName,
          qty: responseData.qty || parseInt(quantity),
          uom: uom,
          createdAt: responseData.createdAt || new Date().toISOString(),
          type: "OUTGOING",
          tagId: responseData.tagId || [],
          grnId: responseData.grnId || [],
          date: responseData.date || today,
          partId: responseData.partId || {},
        };

        setScanItems((prevItems) => [newItem, ...prevItems]);
        getInwardData();
        resetForm();
        fetchAvailableBarcodes();

        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);
      } else {
        setShowDuplicatePopup(true);
        console.error(
          "Failed to process inward transaction:",
          response?.message || response?.msg
        );
      }
    } catch (error: any) {
      console.error("Error processing inward:", error);
      setShowDuplicatePopup(true);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleBarcodeKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      fetchBarcodeDetails(barcodeNo);
    }
  };

  const resetFormFields = () => {
    setBarcode("");
    setPartNo("");
    setPartName("");
    setModel("");
    setCategory("");
    setUom("");
    setQty("");
    setSelectedRack("");
    setSelectedRackName("");
    setSelectedBarcodeTagId("");
  };

  const validateForm = () => {
    const newErrors = {
      barcodeNo: !barcodeNo ? "Barcode No is required" : "",
      selectedRack: !selectedRack ? "Rack is required" : "",
      qty: !qty
        ? "Quantity is required"
        : Number(qty) <= 0
          ? "Quantity must be greater than 0"
          : String(qty).length > 5
            ? "Quantity must not exceed 5 digits"
            : "",
    };

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };
  const handleComplete = async () => {
    setFormSubmitted(true);

    if (!validateForm()) {
      return;
    }

    setIsProcessing(true);
    try {
      const today = new Date().toISOString().split("T")[0];

      const outwardData = {
        tagNumber: barcodeNo,
        tagId: selectedBarcodeTagId,
        date: today,
        rackId: selectedRack,
        qty: parseInt(qty),
      };

      const response = await postData<ApiResponse>(
        "/inwardoptions",
        outwardData
      );

      if (
        response &&
        "statusCode" in response &&
        (response.statusCode === 1127 || response.statusCode === 1001)
      ) {
        setSuccessMessage("Item inward processed successfully");

        let responseData = response.data;
        if (Array.isArray(response.data)) {
          responseData = response.data[0];
        }

        const rackInfo = racks.find((rack) => rack._id === selectedRack);
        const rackName = rackInfo ? rackInfo.rackName : "N/A";

        const newItem: ScanItem = {
          _id: responseData._id || Date.now().toString(),
          tagNumber: responseData.tagNumber || barcodeNo,
          partNo: partNo,
          partName: partName,
          model: model,
          category: category,
          rackId: responseData.rackId || selectedRack,
          rackName: rackName,
          qty: responseData.qty || parseInt(qty),
          uom: uom,
          createdAt: responseData.createdAt || new Date().toISOString(),
          type: "OUTGOING",
          tagId: responseData.tagId || [],
          grnId: responseData.grnId || [],
          date: responseData.date || today,
          partId: responseData.partId || {},
        };

        setScanItems((prevItems) => [newItem, ...prevItems]);

        resetForm();

        fetchAvailableBarcodes();

        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);
      } else {
        setShowDuplicatePopup(true);
        console.error(
          "Failed to process inward transaction:",
          response?.message || response?.msg
        );
      }
    } catch (error: any) {
      console.error("Error processing inward:", error);

      setShowDuplicatePopup(true);
    } finally {
      setIsProcessing(false);
    }
  };

  const resetForm = () => {
    setBarcodeNo("");
    setSelectedRack("");
    setSelectedRackName("");
    resetFormFields();
    setError("");
    setFormSubmitted(false);
    setErrors({
      barcodeNo: "",
      selectedRack: "",
      qty: "",
    });
  };

  const handleCancel = () => {
    resetForm();
  };

  const closeDuplicatePopup = () => {
    setShowDuplicatePopup(false);
    resetForm();
  };

  const handleSortChange = (
    sortByField: string,
    sortOrderDirection: "asc" | "desc"
  ) => {
    setSortBy(sortByField);
    setSortOrder(sortOrderDirection);
  };

  const columns = [
    {
      key: "tagNumber",
      label: "Barcode No",
    },
    {
      key: "partId",
      label: "Part No",
      nameKey: "part.internalPartNo",
      render: (value: any) =>
        typeof value === "object" ? value?.part.internalPartNo : "N/A",
      sortable: true,
    },
    {
      key: "partId",
      label: "Part Name",
      nameKey: "part.partName",
      render: (value: any) =>
        typeof value === "object" ? value?.part.partName : "N/A",
      sortable: true,
    },
    {
      key: "partId",
      label: "model",
      nameKey: "part.modelId.name",
      render: (value: any) =>
        typeof value === "object" ? value?.part.modelId.name : "N/A",
      sortable: true,
    },
    {
      key: "partId",
      label: "category",
      nameKey: "part.categoryId.name",
      render: (value: any) =>
        typeof value === "object" ? value?.part.categoryId.name : "N/A",
      sortable: true,
    },
    { key: "qty", label: "Quantity", sortable: true, isRightAlign: true },
    {
      key: "rackId",
      label: "rack",
      nameKey: "rackname",
      render: (value: any) =>
        typeof value === "object" ? value?.rackName : "N/A",
      sortable: true,
    },
    {
      key: "partId",
      label: "Uom",
      nameKey: "part.uomId.name",
      render: (value: any) =>
        typeof value === "object" ? value?.part.uomId.name : "N/A",
      sortable: true,
    },
  ];

  const getInwardData = async () => {
    setIsLoading(true);
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    const response: any = await getData("/inwardoptions", {
      page: currentPage,
      limit: itemsPerPage,
      filter: filters,
      sortBy: sortBy,
      sortOrder: sortOrder,
      startdate: formattedDate,
      enddate: formattedDate,
    });

    setInwardData(response.data.data);
    setTotalItems(response.data.pagination?.total || 0);
    setTotalPages(response.data.pagination?.totalPages || 0);
    setIsLoading(false);
  };

  useEffect(() => {
    if (initializeInward) {
      getInwardData();
    }
  }, [initializeInward, currentPage, itemsPerPage, filters, sortBy, sortOrder]);

  return (
    <>
      <div className="item-models-header topmargin">
        <div className="border grn-header">
          <div className="start-end-layout">
            <div className="breadcrumb">
              <span className="breadcrumb-current">Inventory</span>
              <span className="breadcrumb-separator"> &gt; </span>
              <span className="breadcrumb-item">Item Inward</span>
            </div>
          </div>
        </div>
      </div>

      <div className="form-container grn-form inward-form">
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          className="add-item-form"
        >
          {successMessage && (
            <div className="success-message">{successMessage}</div>
          )}

          <div className="form-grid">
            <div className="form-group">
              <label>Barcode No:</label>
              <div className="input-error-container">
                <input
                  type="text"
                  name="barcodeNo"
                  value={barcodeNo}
                  onChange={(e) => setBarcodeNo(e.target.value)}
                  onKeyDown={handleBarcodeKeyDown}
                  onPaste={(e) => {
                    const pastedText = e.clipboardData.getData("text");
                    setBarcodeNo(pastedText);
                    fetchBarcodeDetails(pastedText);
                    e.preventDefault();
                  }}
                  onFocus={() => dispatch(setFocusedField("barcodeNo"))}
                  disabled={isEditing || isLoadingBarcode || !permission.menus.inwardoptions.create}
                  className={
                    (formSubmitted && errors.barcodeNo) || error ? "error-input" : ""
                  }
                  placeholder="Enter Barcode Number and press Enter"
                />
                {((formSubmitted && errors.barcodeNo) || error) && (
                  <div className="error-messagegrn">{errors.barcodeNo || error}</div>
                )}
              </div>
            </div>

            <div className="form-group">
              <label>Rack:</label>
              <div className="input-error-container">
                <input
                  type="text"
                  name="rackName"
                  value={selectedRackName}
                  readOnly
                  className={
                    formSubmitted && errors.selectedRack
                      ? "error-input read-only-input"
                      : "read-only-input"
                  }
                />
                <input type="hidden" name="rackId" value={selectedRack} />
                {formSubmitted && errors.selectedRack && (
                  <div className="error-messagegrn">{errors.selectedRack}</div>
                )}
              </div>
            </div>

            <div className="form-group">
              <label>Barcode:</label>
              <div className="input-error-container">
                <input
                  type="text"
                  name="barcode"
                  value={barcode}
                  readOnly
                  className="read-only-input"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Part No:</label>
              <div className="input-error-container">
                <input
                  type="text"
                  name="partNo"
                  value={partNo}
                  readOnly
                  className="read-only-input"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Part Name:</label>
              <div className="input-error-container">
                <input
                  type="text"
                  name="partName"
                  value={partName}
                  readOnly
                  className="read-only-input"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Model:</label>
              <div className="input-error-container">
                <input
                  type="text"
                  name="model"
                  value={model}
                  readOnly
                  className="read-only-input"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Category:</label>
              <div className="input-error-container">
                <input
                  type="text"
                  name="category"
                  value={category}
                  readOnly
                  className="read-only-input"
                />
              </div>
            </div>

            <div className="form-group">
              <label>UOM:</label>
              <div className="input-error-container">
                <input
                  type="text"
                  name="uom"
                  value={uom}
                  readOnly
                  className="read-only-input"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Quantity:</label>
              <div className="input-error-container">
                <input
                  type="text"
                  name="qty"
                  value={qty}
                  readOnly
                  className={
                    formSubmitted && errors.qty
                      ? "error-input read-only-input"
                      : "read-only-input"
                  }
                />
                {formSubmitted && errors.qty && (
                  <div className="error-messagegrn">{errors.qty}</div>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>

      <div className="box-container-inward">
        <div >
          {isLoading ? (
            <div className={inwardStyles.spinner}></div>
          ) : (
            <TableComponent
              columns={columns}
              data={inwardData}
              setFilter={(filters: Record<string, any>) => {
                Object.entries(filters).forEach(([key, value]) => {
                  dispatch(updateFilters({ key, value: String(value) }));
                });
              }}
              setSorting={handleSortChange}
              defaultSortConfig={{ key: sortBy, direction: sortOrder }}
            />
          )}
          {isLoading && (
            <div className="loading-overlay-inward">
              <div className={inwardStyles.spinner}></div>
            </div>
          )}
        </div>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          totalItems={totalItems}
        />
      </div>

      {showDuplicatePopup && (
        <DuplicateEntryPopup onClose={closeDuplicatePopup} />
      )}
    </>
  );
};

export default Scaninward;